module.exports = __webpack_public_path__ + "static/media/empty.1c8a62d1.png";